import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  downloadFile(data: any, filename: string, fileType = 'text/csv'): void {
    const blob = new Blob([data], { type: fileType });
    const url = window.URL.createObjectURL(blob);

    const anchor = this.renderer.createElement('a');
    this.renderer.setAttribute(anchor, 'href', url);
    this.renderer.setAttribute(anchor, 'download', filename);
    this.renderer.setStyle(anchor, 'display', 'none');

    this.renderer.appendChild(document.body, anchor);
    this.renderer.selectRootElement(anchor).click();

    // Cleanup
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      if (anchor.parentNode) {
        this.renderer.removeChild(document.body, anchor);
      }
    }, 100);
  }
}
